import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ParamsAligeService {
  private queryParams: any = {};

  constructor() { }

  setParams(params: any) {
    if(Object.keys(params).length === 0) {
    } else {
      const filteredParams: { [key: string]: any } = {
        utm_source: params.utm_source,
        utm_idcampaign: params.utm_idcampaign,
        utm_idadgroup: params.utm_idadgroup,
        utm_idadname: params.utm_idadname,
        fbclid: params.fbclid,
        ttclid: params.ttclid,
        gclid: params.gclid,
      };

      Object.keys(filteredParams).forEach(key => {
        if (filteredParams[key] == null) {
          delete filteredParams[key];
        }
      });

      // Asignar parametros
      sessionStorage.setItem('paramsCampaign', JSON.stringify(filteredParams));    
      this.queryParams = filteredParams;
    }
  }

  getParams() {
    return this.queryParams;
  }
}
